import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import ImageScroller from '../../components/imagescroller';

import localUtil from '../../lib/util';

@observer
class ImageScrollerFullscreen extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.imageScrollerRef = null;
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        const { onClickClose = () => {} } = this.props;
        if (e.key === 'Escape') {
            onClickClose();
        } else if (e.key === 'ArrowLeft') {
            if (this.imageScrollerRef) {
                this.imageScrollerRef.scrollLeft();
            }
        } else if (e.key === 'ArrowRight') {
            if (this.imageScrollerRef) {
                this.imageScrollerRef.scrollRight();
            }
        }
    }

    onImageClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    render() {
        const {
            images = [],
            imageIdx = 0,
            onClickClose = () => {},
        } = this.props;

        return (<>
            <div
                class='w-100 h-100 d-flex justify-content-center align-items-center fixed-bottom'
                style='bottom: 0; left: 0; background-color: rgba(0, 0, 0, 0.6); max-height: 100vh; z-index: 9999999;'
                onClick={onClickClose}
            >
                <div
                    class='d-flex position-absolute'
                    style='top: 10px; right: 10px; z-index: 10;'
                >
                    <button
                        class='btn btn-secondary'
                        style='border-radius: 50%; width: 40px; height: 40px;'
                        onClick={onClickClose}
                    >
                        <i class='fas fa-times' />
                    </button>
                </div>
                <div
                    class='w-100 h-100 d-flex justify-content-center align-items-center overflow-auto'
                >
                    {images && images.length > 0 ? <div class='d-flex'>
                        <ImageScroller
                            ref={c => { this.imageScrollerRef = c; }}
                            images={images}
                            imageIdx={imageIdx}
                            stores={this.props.stores}
                            showImg={img => localUtil.displayImg(img, this.props, '1920x')}
                            showLargeImage={img => localUtil.displayImg(img, this.props, '1920x')}
                            maxHeight={'90vh'}
                            maxWidth={'95vw'}
                            classNamesWrapper1={`mt-0`}
                            onImageClick={this.onImageClick}
                            isFullscreenMode={true}
                            showFullscreenButton={false}
                        />
                    </div> : null}
                </div>
            </div>
        </>);
    }
}

export default ImageScrollerFullscreen;
